// Port of api/fuel/app/classes/insights/shelf/cumulative.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Config from 'offline/model/config'

function formatFromConfig(userId, timestamp) {
	var format = (((Config.user(userId) || {}).other || {}).date || 'DD/MM/YYYY')
	format = format.replace('DD', 'jS').replace('MM', 'F').replace('YYYY', 'Y')

	// Support only the patterns used here.
	var day = new Date(timestamp * 1000).getUTCDate()
	var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	var month = monthNames[new Date(timestamp * 1000).getUTCMonth()]
	var year = new Date(timestamp * 1000).getUTCFullYear()
	var suffix = 'th'
	if (day % 10 === 1 && day % 100 !== 11) suffix = 'st'
	else if (day % 10 === 2 && day % 100 !== 12) suffix = 'nd'
	else if (day % 10 === 3 && day % 100 !== 13) suffix = 'rd'

	return format.replace('jS', day + suffix).replace('F', month).replace('Y', year)
}

export default Segment.extend({
	name: 'cumulative',
	requires: ['longest'],
	insight: ['cumulative.period', 'cumulative.who'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var cumulative = []
		if (!filter['cumulative.who']) filter['cumulative.who'] = 'designers'
		if (!filter['cumulative.period']) filter['cumulative.period'] = 'alltime'

		var entityType = (filter['cumulative.who'] === 'publishers') ? 'publishers' : 'designers'
		var period = (filter['cumulative.period'] === 'current') ? 'current' : 'all'

		entityType = (vars && vars.cumulative) ? vars.cumulative : entityType
		var specific = (vars && vars.specific) ? vars.specific : false
		var limit = detail ? 1000 : 5

		if ((this._data.longest || []).length) {
			var gameTimes = {}
			for (var i = 0; i < this._data.longest.length; i++) gameTimes[this._data.longest[i].id] = this._data.longest[i]

			var longest = this._data.longest
			if (period === 'current') {
				longest = longest.filter(function(item) {
					return !item.to && !item.played
				})
			}

			var gameIndex = longest.map(function(item) { return parseInt(item.id, 10) })
			var people = {}

			if (gameIndex.length) {
				if (entityType === 'designers') {
					people = Util.queryFast(
						'SELECT group_concat(DISTINCT g.game_id) AS g, g.designer_id AS id, d.designer_name AS n' +
						' FROM game_designer g, designer d WHERE d.designer_id = g.designer_id' +
						' AND g.game_id IN (' + Util.in(gameIndex) + ')' +
						(specific ? (' AND d.designer_id = ' + specific) : '') +
						' GROUP BY d.designer_id',
						null,
						'id'
					)
				} else {
					people = Util.queryFast(
						'SELECT group_concat(DISTINCT g.game_id) AS g, g.publisher_id AS id, p.publisher_name AS n' +
						' FROM game_publisher g, publisher p WHERE p.publisher_id = g.publisher_id' +
						' AND g.game_publisher_primary = 1' +
						' AND g.game_id IN (' + Util.in(gameIndex) + ')' +
						(specific ? (' AND p.publisher_id = ' + specific) : '') +
						' GROUP BY p.publisher_id',
						null,
						'id'
					)
				}

				var peopleKeys = Object.keys(people)
				for (var pk = 0; pk < peopleKeys.length; pk++) {
					var person = people[peopleKeys[pk]]
					var personGames = String(person.g).split(',').map(function(id) { return parseInt(id, 10) }).filter(Boolean)
					var time = 0
					var games = []

					for (var pg = 0; pg < personGames.length; pg++) {
						var gameTime = gameTimes[personGames[pg]]
						if (!gameTime) continue
						time += gameTime.length
						this._references.games.push(parseInt(personGames[pg], 10))

						var colour = 'green'
						var tooltip = 'Current since ' + formatFromConfig(owner.get_id(), gameTime.from)

						if (gameTime.played) {
							colour = 'blue'
							tooltip = 'Played on ' + formatFromConfig(owner.get_id(), gameTime.played)
						} else if (gameTime.to) {
							colour = 'red'
							tooltip = 'Removed ' + formatFromConfig(owner.get_id(), gameTime.to)
						}

						games.push({
							id: parseInt(personGames[pg], 10),
							count: Math.floor(gameTime.length / 86400),
							colour: colour,
							tooltip: tooltip,
							from: gameTime.from,
							to: gameTime.to,
							played: gameTime.played
						})
					}

					games = Util.sort_by_field(games, 'count', 'desc')
					if (games.length > 3 && !specific) games = games.slice(0, 3)

					cumulative.push({
						id: parseInt(person.id, 10),
						name: person.n,
						gamesCount: personGames.length,
						games: games,
						time: time,
						count: Math.floor(time / 86400)
					})
				}

				cumulative = Util.sort_by_field(cumulative, 'time', 'desc')
				if (cumulative.length > limit) cumulative = cumulative.slice(0, limit)
			}
		}

		return {
			cumulative: cumulative
		}
	}
})
